import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CodeSystemModule } from 'app/mdm/terminology/codesystem/codesystem.module';
import { DictionaryModule } from 'app/mdm/terminology/dictionary/dictionary.module';
import { MeasurementUnitModule } from 'app/mdm/terminology/measurment-unit/measurement-unit.module';
import { ObservationDefinitionModule } from 'app/mdm/terminology/observation-definition/observation-definition.module';
import { SnomedModule } from 'app/mdm/terminology/snomed/snomed.module';
import { ObservationGroupModule } from 'app/mdm/terminology/observation-group/observation-group.module';

@NgModule({
  imports: [
    CommonModule,
    CodeSystemModule,
    DictionaryModule,
    ObservationDefinitionModule,
    MeasurementUnitModule,
    SnomedModule,
    ObservationGroupModule,
  ],
  declarations: [],
})
export class TerminologyModule {}
